import { list as getList } from "~/api/counterpartyHistory";
import * as types from "../mutation-types";

export const state = {
  list: null,
  meta: null,
  isLoading: false,
  isInitialLoadPending: true

};

export const mutations = {
  [types.SET_IS_LOADING_COUNTERPARTY_HISTORY](state, status) {
    state.isLoading = status;
  },
  [types.SET_COUNTERPARTY_HISTORY](state, counterpartyHistory) {
    state.list = counterpartyHistory;
    state.isInitialLoadPending = false;
  },
  [types.SET_COUNTERPARTY_HISTORY_META](state, meta) {
    state.meta = meta;
  }
};

export const actions = {
  async fetchCounterpartyHistories({ commit }, params) {
    commit(types.SET_IS_LOADING_COUNTERPARTY_HISTORY, true);

    try {
      const response = await getList(params);
      let { data } = response;

      commit(types.SET_COUNTERPARTY_HISTORY, data.data);
      commit(types.SET_COUNTERPARTY_HISTORY_META, data.meta);
    } catch (e) {
      console.error('Error fetching counterparty histories:', e);
    } finally {
      commit(types.SET_IS_LOADING_COUNTERPARTY_HISTORY, false);
    }
  }
};

export const getters = {
  list: (state) => state.list,
  meta: (state) => state.meta,
  isLoading: (state) => state.isLoading,
  isInitialLoadPending: (state) => state.isInitialLoadPending
};
